import * as React from 'react';
import { connect } from 'react-redux';

import AdminPanel from '../admin-panel/AdminPanel';
import BrandProfileApprovalActions from './BrandProfileApprovalActions';
import BrandProfileTeamActions from './BrandProfileTeamActions';

import { applyTranslations } from 'utils/language';

import './brand-profile-admin-panel.scss';

import { BrandProfile } from 'types';

applyTranslations(require('./brand-profile-admin-panel.i18n.json'));

type OwnProps = {
  brandProfile: BrandProfile
}

type DispatchProps = {
  handleApprovalStatusChanged: () => void
}

type Props = OwnProps & DispatchProps;

const BrandProfileAdminPanel = (props: Props): JSX.Element => {
  const { brandProfile, handleApprovalStatusChanged } = props;

  return (
    <AdminPanel>
      <BrandProfileApprovalActions
        profile={brandProfile}
        onChange={handleApprovalStatusChanged}
      />
      <BrandProfileTeamActions profile={brandProfile} />
    </AdminPanel>
  );
};

export default connect()(BrandProfileAdminPanel);
